// extracted by mini-css-extract-plugin
module.exports = {"container":"MainMenu_container__b0sRk","menuIcon":"MainMenu_menuIcon__iOfYe","isOpen":"MainMenu_isOpen__TcuuY","menuContainer":"MainMenu_menuContainer__2OwTz"};